import {Fragment} from 'react';
import {useCopy} from './config';
import './DrawReference.css';

// Display formatting only; stored draw numbers and financial identifiers stay intact.
export function DrawReference({draw}:{draw:string}){
 return <span className="draw-reference">#{draw.replace(/^#+/,'')}</span>;
}
export function DrawText({copyKey,draw,values={}}:{copyKey:string;draw:string;values?:Record<string,string|number>}){
 const t=useCopy();
 const parts=t(copyKey,{...values,draw:'\uFFFC'}).split(/#?\uFFFC/);
 return <>{parts.map((part,index)=><Fragment key={index}>{index>0&&<DrawReference draw={draw}/>}{part}</Fragment>)}</>;
}
